module.exports = __webpack_public_path__ + "img/circular_layout.c16c912b.svg";